exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".component-button-panel {\n  background-color: #858694;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  flex: 1 0 auto;\n}\n\n.component-button-panel > div {\n  width: 100%;\n  margin-bottom: 1px;\n  flex: 1 0 auto;\n  display: flex;\n}\n", ""]);

